import React from "react";
// COMPONENTS
import { revealProps } from "Components/WebsiteTheme/Reveal";
// STYLES
import { AboutFounderSection } from "./AboutUs.style";
// IMAGES (portrait supplied by Tanisha, Oct 2026)
import FounderPhoto from "Assets/Images/AboutUs/founder-tanisha-ferguson.webp";

/** Meet the Founder: Tanisha Ferguson. */
const AboutFounder = () => (
	<AboutFounderSection className="sm_section">
		<div className="sm_container">
			<div className="af_card" {...revealProps("up")}>
				<img className="af_photo" src={FounderPhoto} alt="Tanisha Ferguson" width="670" height="758" loading="lazy" />
				<div className="af_copy">
					<p className="sm_eyebrow">Meet the founder</p>
					<h2 className="sm_title">Tanisha Ferguson</h2>
					<p className="af_role">Founder, Subjects Master LLC</p>
					<p className="sm_body">
						Tanisha created Subjects Master with the belief that student engagement and teacher control shouldn’t be competing priorities. Her goal is to give educators a powerful,
						easy-to-use platform that helps their students reinforce what they’re learning and build confidence across every subject area.
					</p>
				</div>
				<p className="af_quote sm_h3">
					Empowering Teachers.
					<br />
					<span className="sm_hand_line">Inspiring Students.</span>
				</p>
			</div>
		</div>
	</AboutFounderSection>
);

export default AboutFounder;
